import { render, staticRenderFns } from "./topBgColor.vue?vue&type=template&id=58acade6&scoped=true&"
import script from "./topBgColor.vue?vue&type=script&lang=js&"
export * from "./topBgColor.vue?vue&type=script&lang=js&"
import style0 from "./topBgColor.vue?vue&type=style&index=0&id=58acade6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58acade6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58acade6')) {
      api.createRecord('58acade6', component.options)
    } else {
      api.reload('58acade6', component.options)
    }
    module.hot.accept("./topBgColor.vue?vue&type=template&id=58acade6&scoped=true&", function () {
      api.rerender('58acade6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/topBgColor.vue"
export default component.exports